import React, { memo } from 'react';
import { classNames } from '../../utils/classNames';

const SIZE_CLASSES = {
	md: 'h-9 px-3 py-2 text-xs',
	lg: 'h-11 px-4 py-2.5 text-sm',
};

export const TextField = memo(function TextField({
	id,
	label,
	value,
	onChange,
	onBlur,
	placeholder = '',
	type = 'text',
	required = false,
	disabled = false,
	error,
	className,
	inputClassName,
}) {
	return (
		<div className={classNames('w-full', className)}>
			{label ? (
				<label
					htmlFor={id}
					className='mb-2 block text-sm font-semibold text-zinc-800'
				>
					{label}
					{required ? <span className='text-rose-500'> *</span> : null}
				</label>
			) : null}
			<input
				id={id}
				type={type}
				value={value ?? ''}
				onChange={onChange}
				onBlur={onBlur}
				placeholder={placeholder}
				required={required}
				disabled={disabled}
				className={classNames(
					'w-full rounded-lg border bg-white text-zinc-800 shadow-sm outline-none transition',
					'focus:ring-4 focus:ring-sky-100',
					error
						? 'border-rose-300 focus:border-rose-400'
						: 'border-zinc-200 focus:border-sky-300',
					SIZE_CLASSES.md,
					disabled && 'cursor-not-allowed opacity-60',
					inputClassName,
				)}
			/>
			{error ? (
				<p className='mt-1 text-xs text-rose-600'>{error}</p>
			) : null}
		</div>
	);
});

export default TextField;